import { defineType } from 'sanity';

export default defineType({
	name:   'faqPage',
	title:  'FAQ Page',
	type:   'document',
	fields: [
		{
			name:  'title',
			title: 'Title',
			type:  'localizedText',
		},
		{
			name:  'description',
			title: 'Description',
			type:  'localizedBlockContent',
		},
		{
			name:  'categories',
			title: 'FAQ Categories',
			type:  'array',
			of:    [ { type: 'faqCategory' } ],
		},
	],
	preview: { prepare: () => ({ title: 'FAQ Page' }) },
});
